import React from "react";

export default function BlobBackground() {
  const colors = [
    "#A7F0BA",
    "#9EF0F0",
    "#BAE6FF",
    "#D0E2FF",
    "#E8DAFF",
    "#FFD6E8",
    "#F2F4F8",
  ];
  const blobsCreator = (color) => [
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color}
        d="M35.8,-58.4C49.4,-54.1,65.6,-50.7,70.8,-41C76.1,-31.4,70.5,-15.7,67.8,-1.6C65,12.5,65.1,25.1,61.3,37.2C57.5,49.4,49.8,61.1,38.9,66.4C28.1,71.6,14,70.3,0.6,69.3C-12.8,68.3,-25.7,67.5,-35.6,61.7C-45.6,56,-52.7,45.2,-60.8,34.1C-68.9,23,-78.1,11.5,-81.2,-1.8C-84.4,-15.1,-81.5,-30.3,-73.4,-41.3C-65.2,-52.4,-51.8,-59.4,-38.7,-63.9C-25.5,-68.4,-12.8,-70.5,-0.8,-69.1C11.1,-67.6,22.2,-62.6,35.8,-58.4Z"
        transform="translate(100 100)"
      />
    </svg>,
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color}
        d="M45.4,-76.7C59,-70.7,70.3,-58.9,72.8,-45.2C75.3,-31.4,69.1,-15.7,66.3,-1.6C63.5,12.5,64.3,25,60.8,37.1C57.3,49.2,49.6,60.9,38.8,66.9C27.9,72.9,14,73.2,-0.5,74C-14.9,74.9,-29.8,76.2,-42.3,71.1C-54.8,66.1,-64.9,54.7,-73.3,41.7C-81.8,28.8,-88.7,14.4,-86.9,1C-85.1,-12.3,-74.6,-24.6,-65.3,-36.2C-56,-47.7,-48,-58.5,-37.3,-66.2C-26.7,-73.8,-13.3,-78.3,1.3,-80.5C15.9,-82.7,31.8,-82.6,45.4,-76.7Z"
        transform="translate(100 100)"
      />
    </svg>,
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color}
        d="M38.8,-63.9C53,-59.1,68.8,-54,78,-43.3C87.1,-32.6,89.5,-16.3,88.5,-0.6C87.4,15.1,82.9,30.2,74.5,42.1C66,53.9,53.5,62.5,40.5,70.5C27.4,78.5,13.7,85.9,-1,87.7C-15.7,89.4,-31.5,85.6,-41.4,75.8C-51.4,66,-55.6,50.3,-59.2,36.7C-62.7,23,-65.5,11.5,-68.2,-1.5C-70.8,-14.5,-73.2,-29.1,-67.3,-38.7C-61.4,-48.2,-47.3,-52.8,-34.7,-58.5C-22.1,-64.1,-11.1,-70.7,0.7,-71.9C12.4,-73,24.7,-68.6,38.8,-63.9Z"
        transform="translate(100 100)"
      />
    </svg>,
    // <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     fill={color}
    //     d="M34,-60.3C43.1,-53.6,49,-42.6,58.3,-31.9C67.6,-21.1,80.3,-10.6,82.8,1.4C85.3,13.4,77.5,26.8,68.4,37.9C59.3,49,48.9,57.8,37.2,65.9C25.6,74.1,12.8,81.6,1.1,79.7C-10.6,77.8,-21.2,66.4,-34.4,59.2C-47.6,51.9,-63.3,48.8,-74.5,39.6C-85.7,30.4,-92.3,15.2,-89,1.9C-85.6,-11.3,-72.3,-22.7,-63.2,-35.6C-54.2,-48.4,-49.4,-62.9,-39.6,-69.2C-29.7,-75.5,-14.9,-73.7,-1.2,-71.6C12.4,-69.5,24.8,-67,34,-60.3Z"
    //     transform="translate(100 100)"
    //   />
    // </svg>,
    // <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     fill={color}
    //     d="M39.5,-68.9C50,-62.4,56.4,-49.3,65.6,-36.8C74.7,-24.2,86.6,-12.1,85.2,-0.8C83.7,10.4,69,20.9,59.3,32.5C49.6,44.2,45,57,35.9,64.9C26.9,72.7,13.4,75.5,0.2,75.1C-13,74.7,-25.9,71,-39.6,65.8C-53.2,60.6,-67.6,54,-77.3,42.8C-86.9,31.6,-91.8,15.8,-90.1,1C-88.4,-13.8,-80.1,-27.6,-71,-39.8C-61.9,-51.9,-52,-62.4,-40,-68.1C-28.1,-73.7,-14,-74.6,0.2,-75C14.5,-75.4,29,-75.4,39.5,-68.9Z"
    //     transform="translate(100 100)"
    //   />
    // </svg>,
    // <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     fill={color}
    //     d="M38.8,-61.4C53,-59.1,69,-54.1,78.4,-43.4C87.9,-32.7,90.7,-16.4,87.5,-1.9C84.3,12.7,75,25.3,67,38.5C59,51.7,52.3,65.3,41.4,74.6C30.4,83.8,15.2,88.6,0.6,87.5C-13.9,86.4,-27.9,79.4,-39.6,70.6C-51.4,61.9,-61,51.3,-65.9,39.2C-70.7,27.2,-70.8,13.6,-69,1.1C-67.1,-11.4,-63.3,-22.9,-57.4,-33.1C-51.4,-43.3,-43.4,-52.4,-33.5,-57.1C-23.6,-61.9,-11.8,-62.4,0.3,-62.8C12.3,-63.3,24.7,-63.7,38.8,-61.4Z"
    //     transform="translate(100 100)"
    //   />
    // </svg>,
  ];
  // select 3 blobs from the array
  // change their fill color
  // use them in bg
  const getBlobs = () => {
    // let blob = blobs[Math.floor(Math.random() * blobs.length)];
    const color = colors[Math.floor(Math.random() * colors.length)];
    const blobsArray = blobsCreator(color);
    return blobsArray;
  };
  const blobs = getBlobs();
  return (
    <>
      <div className="absolute -z-10 left-0">
        <div className="h-full w-screen relative">
          <div className="w-[400px] h-[400px] absolute right-40 top-40">
            {blobs[0]}
          </div>
          <div className="w-[400px] h-[400px] absolute left-40">{blobs[1]}</div>
          <div className="w-[400px] h-[400px] absolute top-80">{blobs[2]}</div>
        </div>
      </div>
    </>
  );
}
